import { Component, EventEmitter, OnDestroy, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../state';
import { of, Subscription } from 'rxjs';
import { Logging } from '../../services/logging/logging.service';
import { HaCussService } from '../../services/ha-cuss/ha-cuss.service';
import { DeleteCart } from 'src/app/state/cart/cart.actions';
import { socketAlive } from '../../services/emitters/session-event-emitters';
import { AppRoutes } from 'src/app/app-routing.module';

@Component({
  selector: 'app-start-over',
  templateUrl: './start-over.component.html',
  styleUrls: ['./start-over.component.scss'],
})
export class StartOverComponent implements OnInit, OnDestroy {
  public showModal = false;
  public step = 'step-0';
  clearStateSubscription: Subscription;

  @Output() clicked = new EventEmitter<any>();
  @ViewChild('acaa', { static: false }) buttonElement: ElementRef;

  constructor(
    public router: Router,
    public logging: Logging,
    private store: Store<AppState>,
    private haCussService: HaCussService
  ) {
    if (this.router.url.indexOf('locate-reservation') > 0) {
      this.step = 'step-1';
    }
    if (this.router.url.indexOf('itinerary') > 0 || this.router.url.indexOf('hazmat') > 0) {
      this.step = 'step-2';
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.clearStateSubscription) {
      this.clearStateSubscription.unsubscribe();
    }
  }

  toggleModal(status) {
    this.showModal = status;

    if (this.showModal) {
      this.clicked.emit();
      this.logging.infoUiStartOverSelected();
      this.logging.infoUiStartOverPageDisplayed(0);
    } else {
      this.logging.infoUiStartOverPageNoSelected(0);
    }
  }

  doStartOver() {
    this.logging.infoUiStartOverPageYesSelected(0);
    if (this.haCussService.getAtbPrinterStatus()[1] === true) {
      socketAlive.emit(false);
    }

    this.store.dispatch(new DeleteCart());
    this.clearStateSubscription = of(this.store.dispatch({ type: 'clearState' })).subscribe(() => {
      this.logging.infoUiCheckinCancelled();
      this.router.navigate([AppRoutes.MENU]);
    });
  }
}
